import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import {
  ExpansionPanel,
  ExpansionPanelContent,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import React, { useEffect } from "react";
import { FiEdit } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonForAll from "../../components/common/ButtonForAll";
import {
  createHotelSpecialRate,
  deleteHotelSpecialRate,
  getAllActiveHotelRoomCategory,
  getHotelByID,
  updateHotelSpecialRate,
} from "./services/hotel.services";
import ShadowCard from "../../components/common/ShadowCard";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { clearHotelSpecialRateID, setHotelSpecialRateID } from "./hotelSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { MdDelete } from "react-icons/md";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { CNBAGEArray, STATUSARRAY } from "../../_contstants/common";
import moment from "moment";
import FormDatePicker from "../../components/formFields/FormDateField";
import {
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { Reveal } from "@progress/kendo-react-animation";
import RippleButton from "../../components/common/RippleButton";
import IconButton from "../../components/common/IconButton";
import { getAllActiveFestivals } from "../festival/services/festivals.services";
import { IFestivals } from "../festival/festivalsModel";

interface SpecialRateChangeWatcherProps {
  formRenderProps: FormRenderProps;
  handleClearSpecialRateDetails: any;
}

const SpecialRateChangeWatcher: React.FC<SpecialRateChangeWatcherProps> = ({
  formRenderProps,
  handleClearSpecialRateDetails,
}) => {
  const HotelDetail = useAppSelector((state) => state.hotel.HotelDetail);

  useEffect(() => {
    handleClearSpecialRateDetails(formRenderProps);
  }, [HotelDetail]);

  return null;
};

const CreateHotelSpecialRate = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const HotelID = location.state?.HotelID;
  const HotelSpecialRateDetails = useAppSelector(
    (state) => state.hotel.HotelSpecialRateDetails
  );
  const ActiveHotelRoomCategoryList = useAppSelector(
    (state) => state.hotel.ActiveHotelRoomCategoryList
  );
  const HotelDetail = useAppSelector((state) => state.hotel.HotelDetail);
  const FestivalsList = useAppSelector(
    (state) => state.festivals.FestivalsList
  );

  const [expandedStates, setExpandedStates] = React.useState<{
    weekdays: number | null;
    weekend: number | null;
    specialDates: number | null;
  }>({
    weekdays: null,
    weekend: null,
    specialDates: null,
  });

  useEffect(() => {
    dispatch(getAllActiveHotelRoomCategory({ HotelID: HotelID }));
    dispatch(getAllActiveFestivals());
    // dispatch(getAllActiveHotelRoomCategory());
  }, []);

  const handleExpansion = (
    listKey: "weekdays" | "weekend" | "specialDates",
    index: number | null
  ) => {
    setExpandedStates((prev) => ({
      ...prev,
      [listKey]: prev[listKey] === index ? null : index,
    }));
  };

  const MyEditHotelCommandCell = (
    props: any,
    formRenderProps: FormRenderProps
  ) => {
    const handleEdit = (e: any, item: any) => {
      e.stopPropagation();
      formRenderProps.onChange("hotel_special_rate_id", {
        value: item?.ID,
      });
      formRenderProps.onChange("DateType", {
        value: item?.DateType,
      });
      formRenderProps.onChange("RoomCategoryID", {
        value: item?.RoomCategoryID,
      });
      formRenderProps.onChange("FestivalID", {
        value: item?.FestivalID,
      });
      formRenderProps.onChange("FromDate", {
        value: item?.FromDate
          ? moment(item?.FromDate, "DD/MM/YYYY").toDate()
          : "",
      });
      formRenderProps.onChange("ToDate", {
        value: item?.ToDate ? moment(item?.ToDate, "DD/MM/YYYY").toDate() : "",
      });
      formRenderProps.onChange("SOEPAI", {
        value: item?.SOEPAI || 0,
      });
      formRenderProps.onChange("SOCPAI", {
        value: item?.SOCPAI || 0,
      });
      formRenderProps.onChange("SOMAPAI", {
        value: item?.SOMAPAI || 0,
      });
      formRenderProps.onChange("SOAPAI", {
        value: item?.SOAPAI || 0,
      });
      formRenderProps.onChange("DOEPAI", {
        value: item?.DOEPAI || 0,
      });
      formRenderProps.onChange("DOCPAI", {
        value: item?.DOCPAI || 0,
      });
      formRenderProps.onChange("DOMAPAI", {
        value: item?.DOMAPAI || 0,
      });
      formRenderProps.onChange("DOAPAI", {
        value: item?.DOAPAI || 0,
      });
      formRenderProps.onChange("CNBAge", {
        value: `${item?.CNBAge}`,
      });
      formRenderProps.onChange("CWBEPAI", {
        value: item?.CWBEPAI || 0,
      });
      formRenderProps.onChange("CWBCPAI", {
        value: item?.CWBCPAI || 0,
      });
      formRenderProps.onChange("CWBMAPAI", {
        value: item?.CWBMAPAI || 0,
      });
      formRenderProps.onChange("CWBAPAI", {
        value: item?.CWBAPAI || 0,
      });
      formRenderProps.onChange("CNBEPAI", {
        value: item?.CNBEPAI || 0,
      });
      formRenderProps.onChange("CNBCPAI", {
        value: item?.CNBCPAI || 0,
      });
      formRenderProps.onChange("CNBMAPAI", {
        value: item?.CNBMAPAI || 0,
      });
      formRenderProps.onChange("CNBAPAI", {
        value: item?.CNBAPAI || 0,
      });
      formRenderProps.onChange("EAEPAI", {
        value: item?.EAEPAI || 0,
      });
      formRenderProps.onChange("EACPAI", {
        value: item?.EACPAI || 0,
      });
      formRenderProps.onChange("EAMAPAI", {
        value: item?.EAMAPAI || 0,
      });
      formRenderProps.onChange("EAAPAI", {
        value: item?.EAAPAI || 0,
      });
      formRenderProps.onChange("KitchenCharges", {
        value: item?.KitchenCharges || 0,
      });
      formRenderProps.onChange("IsActive", {
        value: item?.IsActive === true ? 1 : 2,
      });
    };

    const handleOpenDeleteDialog = (e: any, ID: number) => {
      e.stopPropagation();
      dispatch(openDialog("deleteHotelSpecialRate"));
      dispatch(setHotelSpecialRateID(ID));
    };

    return (
      <td
        className={props.className}
        style={{
          ...props.style,
          textAlign: "center",
          display: "flex",
          justifyContent: "space-evenly",
        }}
      >
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Edit"
          themeColor={"primary"}
          style={{ height: 35, width: 35 }}
          onClick={(e: any) => handleEdit(e, props)}
          icon={FiEdit}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "20px" }}
        />

        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Delete"
          themeColor={"primary"}
          style={{ height: 35, width: 35 }}
          onClick={(e: any) => handleOpenDeleteDialog(e, props.ID)}
          icon={MdDelete}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
      </td>
    );
  };

  const handleClearSpecialRateDetails = (formRenderProps: FormRenderProps) => {
    formRenderProps.onChange("hotel_special_rate_id", {
      value: "",
    });
    formRenderProps.onChange("DateType", {
      value: null,
    });
    formRenderProps.onChange("RoomCategoryID", {
      value: null,
    });
    formRenderProps.onChange("FestivalID", {
      value: "",
    });
    formRenderProps.onChange("FromDate", {
      value: "",
    });
    formRenderProps.onChange("ToDate", {
      value: "",
    });
    formRenderProps.onChange("SOEPAI", {
      value: 0,
    });
    formRenderProps.onChange("SOCPAI", {
      value: 0,
    });
    formRenderProps.onChange("SOMAPAI", {
      value: 0,
    });
    formRenderProps.onChange("SOAPAI", {
      value: 0,
    });
    formRenderProps.onChange("DOEPAI", {
      value: 0,
    });
    formRenderProps.onChange("DOCPAI", {
      value: 0,
    });
    formRenderProps.onChange("DOMAPAI", {
      value: 0,
    });
    formRenderProps.onChange("DOAPAI", {
      value: 0,
    });
    formRenderProps.onChange("CNBAge", {
      value: "5",
    });
    formRenderProps.onChange("CWBEPAI", {
      value: 0,
    });
    formRenderProps.onChange("CWBCPAI", {
      value: 0,
    });
    formRenderProps.onChange("CWBMAPAI", {
      value: 0,
    });
    formRenderProps.onChange("CWBAPAI", {
      value: 0,
    });
    formRenderProps.onChange("CNBEPAI", {
      value: 0,
    });
    formRenderProps.onChange("CNBCPAI", {
      value: 0,
    });
    formRenderProps.onChange("CNBMAPAI", {
      value: 0,
    });
    formRenderProps.onChange("CNBAPAI", {
      value: 0,
    });
    formRenderProps.onChange("EAEPAI", {
      value: 0,
    });
    formRenderProps.onChange("EACPAI", {
      value: 0,
    });
    formRenderProps.onChange("EAMAPAI", {
      value: 0,
    });
    formRenderProps.onChange("EAAPAI", {
      value: 0,
    });
    formRenderProps.onChange("KitchenCharges", {
      value: 0,
    });
    formRenderProps.onChange("IsActive", {
      value: 1,
    });
  };

  const handleSubmit = async (values: any) => {
    try {
      if (!values?.hotel_special_rate_id) {
        const insertPayload = {
          HotelID: HotelID ? HotelID : null,
          DateType: values?.DateType ? +values?.DateType : null,
          RoomCategoryID: values?.RoomCategoryID
            ? +values?.RoomCategoryID
            : null,
          FestivalID: values?.FestivalID ? +values?.FestivalID : null,
          FromDate: values?.FromDate
            ? moment(values?.FromDate).format("YYYY-MM-DD")
            : null,
          ToDate: values?.ToDate
            ? moment(values?.ToDate).format("YYYY-MM-DD")
            : null,
          SOEPAI: values?.SOEPAI ? +values?.SOEPAI : null,
          SOCPAI: values?.SOCPAI ? +values?.SOCPAI : null,
          SOMAPAI: values?.SOMAPAI ? +values?.SOMAPAI : null,
          SOAPAI: values?.SOAPAI ? +values?.SOAPAI : null,
          DOEPAI: values?.DOEPAI ? +values?.DOEPAI : null,
          DOCPAI: values?.DOCPAI ? +values?.DOCPAI : null,
          DOMAPAI: values?.DOMAPAI ? +values?.DOMAPAI : null,
          DOAPAI: values?.DOAPAI ? +values?.DOAPAI : null,
          CNBAge: values?.CNBAge ? +values?.CNBAge : null,
          CWBEPAI: values?.CWBEPAI ? +values?.CWBEPAI : null,
          CWBCPAI: values?.CWBCPAI ? +values?.CWBCPAI : null,
          CWBMAPAI: values?.CWBMAPAI ? +values?.CWBMAPAI : null,
          CWBAPAI: values?.CWBAPAI ? +values?.CWBAPAI : null,
          CNBEPAI: values?.CNBEPAI ? +values?.CNBEPAI : null,
          CNBCPAI: values?.CNBCPAI ? +values?.CNBCPAI : null,
          CNBMAPAI: values?.CNBMAPAI ? +values?.CNBMAPAI : null,
          CNBAPAI: values?.CNBAPAI ? +values?.CNBAPAI : null,
          //   EAEPAI: values?.EAEPAI ? +values?.EAEPAI : null,
          //   EACPAI: values?.EACPAI ? +values?.EACPAI : null,
          //   EAMAPAI: values?.EAMAPAI ? +values?.EAMAPAI : null,
          //   EAAPAI: values?.EAAPAI ? +values?.EAAPAI : null,
          KitchenCharges: values?.KitchenCharges
            ? +values?.KitchenCharges
            : null,
          IsActive: values?.IsActive === 1,
        };
        const response = await dispatch(createHotelSpecialRate(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(getHotelByID(HotelID));
        }
      } else {
        const updatePayload = {
          ID: values?.hotel_special_rate_id
            ? values?.hotel_special_rate_id
            : null,
          HotelID: HotelID ? HotelID : null,
          DateType: values?.DateType ? +values?.DateType : null,
          RoomCategoryID: values?.RoomCategoryID
            ? +values?.RoomCategoryID
            : null,
          FestivalID: values?.FestivalID ? +values?.FestivalID : null,
          FromDate: values?.FromDate
            ? moment(values?.FromDate).format("YYYY-MM-DD")
            : null,
          ToDate: values?.ToDate
            ? moment(values?.ToDate).format("YYYY-MM-DD")
            : null,
          SOEPAI: values?.SOEPAI ? +values?.SOEPAI : null,
          SOCPAI: values?.SOCPAI ? +values?.SOCPAI : null,
          SOMAPAI: values?.SOMAPAI ? +values?.SOMAPAI : null,
          SOAPAI: values?.SOAPAI ? +values?.SOAPAI : null,
          DOEPAI: values?.DOEPAI ? +values?.DOEPAI : null,
          DOCPAI: values?.DOCPAI ? +values?.DOCPAI : null,
          DOMAPAI: values?.DOMAPAI ? +values?.DOMAPAI : null,
          DOAPAI: values?.DOAPAI ? +values?.DOAPAI : null,
          CNBAge: values?.CNBAge ? +values?.CNBAge : null,
          CWBEPAI: values?.CWBEPAI ? +values?.CWBEPAI : null,
          CWBCPAI: values?.CWBCPAI ? +values?.CWBCPAI : null,
          CWBMAPAI: values?.CWBMAPAI ? +values?.CWBMAPAI : null,
          CWBAPAI: values?.CWBAPAI ? +values?.CWBAPAI : null,
          CNBEPAI: values?.CNBEPAI ? +values?.CNBEPAI : null,
          CNBCPAI: values?.CNBCPAI ? +values?.CNBCPAI : null,
          CNBMAPAI: values?.CNBMAPAI ? +values?.CNBMAPAI : null,
          CNBAPAI: values?.CNBAPAI ? +values?.CNBAPAI : null,
          //   EAEPAI: values?.EAEPAI ? +values?.EAEPAI : null,
          //   EACPAI: values?.EACPAI ? +values?.EACPAI : null,
          //   EAMAPAI: values?.EAMAPAI ? +values?.EAMAPAI : null,
          //   EAAPAI: values?.EAAPAI ? +values?.EAAPAI : null,
          KitchenCharges: values?.KitchenCharges
            ? +values?.KitchenCharges
            : null,
          IsActive: values?.IsActive === 1,
        };
        const response = await dispatch(updateHotelSpecialRate(updatePayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(getHotelByID(HotelID));
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      <DeleteHotelSpecialRateDialog />
      <Form
        initialValues={HotelSpecialRateDetails}
        onSubmit={handleSubmit}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard
              style={{
                padding: 10,
                marginBottom: 10,
                marginTop: 10,
              }}
            >
              <GridLayout
                cols={[{ width: "100%" }]}
                style={{ marginBottom: 20 }}
              >
                <GridLayoutItem>
                  <Typography.h4 className="text-dark">
                    {"Hotel Special Rate"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <GridLayout
                    gap={{ rows: 0, cols: "0.5%" }}
                    cols={[
                      { width: "32%" },
                      { width: "33.33%" },
                      { width: "33.33%" },
                    ]}
                  >
                    <GridLayoutItem style={{ width: "100%" }}>
                      <Field
                        name="DateType"
                        placeholder="Date Type"
                        label="Date Type"
                        astrike={true}
                        validator={requiredValidator}
                        component={FormSelectionField}
                        options={[
                          { label: "Special Rate", value: 1 },
                          { label: "Weekdays", value: 2 },
                          { label: "Weekend", value: 3 },
                        ]}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem style={{ width: "100%" }}>
                      <Field
                        name="RoomCategoryID"
                        placeholder="Room Category"
                        label="Room Category"
                        astrike={true}
                        validator={requiredValidator}
                        component={FormSelectionField}
                        options={ActiveHotelRoomCategoryList?.map(
                          (status: any) => {
                            return {
                              value: status?.ID,
                              label: status?.RoomCategoryName,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                    {formRenderProps.valueGetter("DateType") === 1 && (
                      <GridLayoutItem style={{ width: "100%" }}>
                        <Field
                          name="FestivalID"
                          placeholder="Festival"
                          label="Festival"
                          astrike={
                            formRenderProps.valueGetter("DateType") === 1
                              ? true
                              : false
                          }
                          component={FormSelectionField}
                          validator={
                            formRenderProps.valueGetter("DateType") === 1
                              ? requiredValidator
                              : skipValidator
                          }
                          options={FestivalsList?.map((status: IFestivals) => {
                            return {
                              value: status?.ID,
                              label: status?.Title,
                            };
                          })}
                        />
                      </GridLayoutItem>
                    )}
                    <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperStyle={{ width: "100%" }}
                        name={"FromDate"}
                        label="From Date"
                        format="dd/MM/yyyy"
                        component={FormDatePicker}
                        astrike={
                          formRenderProps.valueGetter("DateType") === 1
                            ? true
                            : false
                        }
                        validator={
                          formRenderProps.valueGetter("DateType") === 1
                            ? requiredValidator
                            : skipValidator
                        }
                      />
                      <Field
                        wrapperStyle={{ width: "100%" }}
                        name={"ToDate"}
                        label="To Date"
                        format="dd/MM/yyyy"
                        minDate={moment(
                          formRenderProps.valueGetter("FromDate")
                        ).toDate()}
                        component={FormDatePicker}
                        astrike={
                          formRenderProps.valueGetter("DateType") === 1
                            ? true
                            : false
                        }
                        validator={
                          formRenderProps.valueGetter("DateType") === 1
                            ? requiredValidator
                            : skipValidator
                        }
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100 right-aligned-field"
                        name={`KitchenCharges`}
                        label="Kitchen Charges"
                        placeholder="0"
                        component={FormNumericTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem style={{ width: "100%" }}>
                      <Field
                        name="IsActive"
                        label="Status"
                        astrike={true}
                        validator={requiredValidator}
                        placeholder="i.e. Active"
                        component={FormSelectionField}
                        options={STATUSARRAY?.map((status: any) => {
                          return {
                            value: status?.value,
                            label: status?.label,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      colSpan={3}
                      style={{
                        borderTop: "1px solid lightgray",
                        marginTop: 25,
                        paddingTop: 15,
                      }}
                    >
                      <GridLayout
                        style={{
                          marginRight: 40,
                        }}
                        gap={{ rows: 10, cols: 10 }}
                        cols={[
                          { width: "20%" },
                          { width: "20%" },
                          { width: "20%" },
                          { width: "20%" },
                          { width: "20%" },
                        ]}
                      >
                        <GridLayoutItem className="fw-600"></GridLayoutItem>
                        <GridLayoutItem className="fw-600">EPAI</GridLayoutItem>
                        <GridLayoutItem className="fw-600">CPAI</GridLayoutItem>
                        <GridLayoutItem className="fw-600">
                          MAPAI
                        </GridLayoutItem>
                        <GridLayoutItem className="fw-600">APAI</GridLayoutItem>

                        <GridLayoutItem className="fw-600">
                          Single Occupancy
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`SOEPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`SOCPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`SOMAPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`SOAPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>

                        <GridLayoutItem className="fw-600">
                          Double Occupancy
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`DOEPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`DOCPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`DOMAPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`DOAPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>

                        <GridLayoutItem className="fw-600">
                          ExtraAdults / CWB.
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`CWBEPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`CWBCPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`CWBMAPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`CWBAPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>

                        <GridLayoutItem className="d-flex gap-2 fw-600">
                          CNB
                          <Field
                            wrapperClassName="m-0"
                            name="CNBAge"
                            placeholder="0"
                            component={FormSelectionField}
                            options={CNBAGEArray?.map((status: any) => {
                              return {
                                value: status?.value,
                                label: status?.label,
                              };
                            })}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`CNBEPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`CNBCPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`CNBMAPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>
                        <GridLayoutItem>
                          <Field
                            wrapperClassName="m-0 w-100 right-aligned-field"
                            name={`CNBAPAI`}
                            placeholder="0"
                            component={FormNumericTextField}
                          />
                        </GridLayoutItem>
                      </GridLayout>
                    </GridLayoutItem>
                    <GridLayoutItem
                      colSpan={3}
                      style={{
                        textAlign: "end",
                        marginTop: 36,
                        paddingBottom: 20,
                        borderBottom: "1px solid lightgray",
                      }}
                    >
                      <ButtonForAll
                        label={
                          formRenderProps.valueGetter("hotel_special_rate_id")
                            ? "Update"
                            : "Add"
                        }
                        disabled={!formRenderProps.allowSubmit}
                        type="submit"
                      />
                      <Button
                        style={{ marginLeft: 4 }}
                        fillMode={"outline"}
                        themeColor={"primary"}
                        type="button"
                        onClick={() => {
                          handleClearSpecialRateDetails(formRenderProps);
                        }}
                      >
                        Clear
                      </Button>
                      <RippleButton
                        type="button"
                        fillMode="outline"
                        themeColor="primary"
                        style={{ marginLeft: 4 }}
                        onClick={() => navigate("/hotel")}
                      >
                        Cancel
                      </RippleButton>
                    </GridLayoutItem>
                  </GridLayout>
                </GridLayoutItem>
              </GridLayout>
              {HotelDetail &&
                HotelDetail.WeekDaysRateList &&
                HotelDetail.WeekDaysRateList.length > 0 && (
                  <>
                    <h5
                      style={{
                        marginBottom: 10,
                        paddingBottom: 10,
                        fontWeight: 600,
                        // borderBottom: "1px solid lightgray",
                      }}
                    >
                      Hotel Rates (Weekdays)
                    </h5>
                    {HotelDetail.WeekDaysRateList.map(
                      (rate: any, index: number) => (
                        <ExpansionPanel
                          title={
                            <table style={{ width: "100%" }}>
                              <tr>
                                <td style={{ width: "30%" }}>
                                  <div style={{ width: "50%", float: "left" }}>
                                    Category:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.RoomCategoryName}
                                  </div>
                                </td>
                                <td style={{ width: "30%" }}>
                                  <div style={{ width: "50%", float: "left" }}>
                                    From Date:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.FromDate}
                                  </div>
                                </td>
                                <td style={{ width: "30%" }}>
                                  <div style={{ width: "50%", float: "left" }}>
                                    To Date:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.ToDate}
                                  </div>
                                </td>
                                <td style={{ width: "10%" }} rowSpan={3}>
                                  {MyEditHotelCommandCell(
                                    rate,
                                    formRenderProps
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div style={{ width: "50%", float: "left" }}>
                                    SOEPAI:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.SOEPAI || 0}
                                  </div>
                                </td>
                                <td>
                                  <div style={{ width: "50%", float: "left" }}>
                                    DOEPAI:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.DOEPAI || 0}
                                  </div>
                                </td>
                                <td>
                                  <div style={{ width: "50%", float: "left" }}>
                                    CWBEPAI:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.CWBEPAI || 0}
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div style={{ width: "50%", float: "left" }}>
                                    CNBEPAI:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.CNBEPAI || 0}
                                  </div>
                                </td>
                                <td>
                                  <div style={{ width: "50%", float: "left" }}>
                                    Kitchen Charges:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.KitchenCharges || 0}
                                  </div>
                                </td>
                              </tr>
                            </table>
                          }
                          expanded={expandedStates.weekdays === index}
                          tabIndex={0}
                          key={rate.ID}
                          onAction={() => {
                            handleExpansion("weekdays", index);
                          }}
                        >
                          <Reveal>
                            {expandedStates.weekdays === index && (
                              <ExpansionPanelContent>
                                <table
                                  className="hotel-special-rate"
                                  style={{
                                    marginRight: 40,
                                    width: "100%",
                                  }}
                                >
                                  <tr
                                    className="fw-600"
                                    style={{ background: "#e5f4ff" }}
                                  >
                                    <th style={{ width: "28%" }}></th>
                                    <th style={{ width: "18%" }}>EPAI</th>
                                    <th style={{ width: "18%" }}>CPAI</th>
                                    <th style={{ width: "18%" }}>MAPAI</th>
                                    <th style={{ width: "18%" }}>APAI</th>
                                  </tr>

                                  <tr>
                                    <td className="fw-600">Single Occupancy</td>
                                    <td className="fw-600">
                                      {rate?.SOEPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.SOCPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.SOMAPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.SOAPAI || 0}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td className="fw-600">Double Occupancy</td>
                                    <td className="fw-600">
                                      {rate?.DOEPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.DOCPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.DOMAPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.DOAPAI || 0}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td className="fw-600">
                                      ExtraAdults / CWB.
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CWBEPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CWBCPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CWBMAPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CWBAPAI || 0}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td className="fw-600">CNB</td>
                                    <td className="fw-600">
                                      {rate?.CNBEPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CNBCPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CNBMAPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CNBAPAI || 0}
                                    </td>
                                  </tr>
                                </table>
                              </ExpansionPanelContent>
                            )}
                          </Reveal>
                        </ExpansionPanel>
                      )
                    )}
                  </>
                )}
              {HotelDetail &&
                HotelDetail.WeekEndRateList &&
                HotelDetail.WeekEndRateList.length > 0 && (
                  <>
                    <h5
                      style={{
                        marginBottom: 10,
                        marginTop: 10,
                        paddingBottom: 10,
                        fontWeight: 600,
                        // borderBottom: "1px solid lightgray",
                      }}
                    >
                      Hotel Rates (Weekends)
                    </h5>
                    {HotelDetail.WeekEndRateList.map(
                      (rate: any, index: number) => (
                        <ExpansionPanel
                          title={
                            <table style={{ width: "100%" }}>
                              <tr>
                                <td style={{ width: "30%" }}>
                                  <div style={{ width: "50%", float: "left" }}>
                                    Category:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.RoomCategoryName}
                                  </div>
                                </td>
                                <td style={{ width: "30%" }}>
                                  <div style={{ width: "50%", float: "left" }}>
                                    From Date:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.FromDate}
                                  </div>
                                </td>
                                <td style={{ width: "30%" }}>
                                  <div style={{ width: "50%", float: "left" }}>
                                    To Date:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.ToDate}
                                  </div>
                                </td>
                                <td style={{ width: "10%" }} rowSpan={3}>
                                  {MyEditHotelCommandCell(
                                    rate,
                                    formRenderProps
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div style={{ width: "50%", float: "left" }}>
                                    SOEPAI:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.SOEPAI || 0}
                                  </div>
                                </td>
                                <td>
                                  <div style={{ width: "50%", float: "left" }}>
                                    DOEPAI:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.DOEPAI || 0}
                                  </div>
                                </td>
                                <td>
                                  <div style={{ width: "50%", float: "left" }}>
                                    CWBEPAI:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.CWBEPAI || 0}
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <div style={{ width: "50%", float: "left" }}>
                                    CNBEPAI:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.CNBEPAI || 0}
                                  </div>
                                </td>
                                <td>
                                  <div style={{ width: "50%", float: "left" }}>
                                    Kitchen Charges:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.KitchenCharges || 0}
                                  </div>
                                </td>
                              </tr>
                            </table>
                          }
                          expanded={expandedStates.weekend === index}
                          tabIndex={0}
                          key={rate.ID}
                          onAction={() => {
                            handleExpansion("weekend", index);
                          }}
                        >
                          <Reveal>
                            {expandedStates.weekend === index && (
                              <ExpansionPanelContent>
                                <table
                                  className="hotel-special-rate"
                                  style={{
                                    marginRight: 40,
                                    width: "100%",
                                  }}
                                >
                                  <tr
                                    className="fw-600"
                                    style={{ background: "#e5f4ff" }}
                                  >
                                    <th style={{ width: "28%" }}></th>
                                    <th style={{ width: "18%" }}>EPAI</th>
                                    <th style={{ width: "18%" }}>CPAI</th>
                                    <th style={{ width: "18%" }}>MAPAI</th>
                                    <th style={{ width: "18%" }}>APAI</th>
                                  </tr>

                                  <tr>
                                    <td className="fw-600">Single Occupancy</td>
                                    <td className="fw-600">
                                      {rate?.SOEPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.SOCPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.SOMAPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.SOAPAI || 0}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td className="fw-600">Double Occupancy</td>
                                    <td className="fw-600">
                                      {rate?.DOEPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.DOCPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.DOMAPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.DOAPAI || 0}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td className="fw-600">
                                      ExtraAdults / CWB.
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CWBEPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CWBCPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CWBMAPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CWBAPAI || 0}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td className="fw-600">CNB</td>
                                    <td className="fw-600">
                                      {rate?.CNBEPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CNBCPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CNBMAPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CNBAPAI || 0}
                                    </td>
                                  </tr>
                                </table>
                              </ExpansionPanelContent>
                            )}
                          </Reveal>
                        </ExpansionPanel>
                      )
                    )}
                  </>
                )}
              {HotelDetail &&
                HotelDetail.SpecialDateRateList &&
                HotelDetail.SpecialDateRateList.length > 0 && (
                  <>
                    <h5
                      style={{
                        marginBottom: 10,
                        marginTop: 10,
                        paddingBottom: 10,
                        fontWeight: 600,
                        // borderBottom: "1px solid lightgray",
                      }}
                    >
                      Hotel Rates (Special Rates)
                    </h5>
                    {HotelDetail.SpecialDateRateList.map(
                      (rate: any, index: number) => (
                        <ExpansionPanel
                          title={
                            <table style={{ width: "100%" }}>
                              <tr>
                                <td style={{ width: "30%" }}>
                                  <div style={{ width: "50%", float: "left" }}>
                                    Category:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.RoomCategoryName}
                                  </div>
                                </td>
                                <td style={{ width: "30%" }}>
                                  <div style={{ width: "50%", float: "left" }}>
                                    Festival:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.FestivalName}
                                  </div>
                                </td>
                                <td style={{ width: "30%" }}>
                                  <div style={{ width: "50%", float: "left" }}>
                                    From Date:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.FromDate}
                                  </div>
                                </td>
                                <td style={{ width: "10%" }} rowSpan={2}>
                                  {MyEditHotelCommandCell(
                                    rate,
                                    formRenderProps
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ width: "30%" }}>
                                  <div style={{ width: "50%", float: "left" }}>
                                    To Date:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.ToDate}
                                  </div>
                                </td>
                                <td>
                                  <div style={{ width: "50%", float: "left" }}>
                                    Kitchen Charges:
                                  </div>
                                  <div style={{ width: "50%", float: "right" }}>
                                    {rate?.KitchenCharges || 0}
                                  </div>
                                </td>
                              </tr>
                            </table>
                          }
                          expanded={expandedStates.specialDates === index}
                          tabIndex={0}
                          key={rate.ID}
                          onAction={() => {
                            handleExpansion("specialDates", index);
                          }}
                        >
                          <Reveal>
                            {expandedStates.specialDates === index && (
                              <ExpansionPanelContent>
                                <table
                                  className="hotel-special-rate"
                                  style={{
                                    marginRight: 40,
                                    width: "100%",
                                  }}
                                >
                                  <tr
                                    className="fw-600"
                                    style={{ background: "#e5f4ff" }}
                                  >
                                    <th style={{ width: "28%" }}></th>
                                    <th style={{ width: "18%" }}>EPAI</th>
                                    <th style={{ width: "18%" }}>CPAI</th>
                                    <th style={{ width: "18%" }}>MAPAI</th>
                                    <th style={{ width: "18%" }}>APAI</th>
                                  </tr>

                                  <tr>
                                    <td className="fw-600">Single Occupancy</td>
                                    <td className="fw-600">
                                      {rate?.SOEPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.SOCPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.SOMAPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.SOAPAI || 0}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td className="fw-600">Double Occupancy</td>
                                    <td className="fw-600">
                                      {rate?.DOEPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.DOCPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.DOMAPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.DOAPAI || 0}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td className="fw-600">
                                      ExtraAdults / CWB.
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CWBEPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CWBCPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CWBMAPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CWBAPAI || 0}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td className="fw-600">CNB</td>
                                    <td className="fw-600">
                                      {rate?.CNBEPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CNBCPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CNBMAPAI || 0}
                                    </td>
                                    <td className="fw-600">
                                      {rate?.CNBAPAI || 0}
                                    </td>
                                  </tr>
                                </table>
                              </ExpansionPanelContent>
                            )}
                          </Reveal>
                        </ExpansionPanel>
                      )
                    )}
                  </>
                )}
            </ShadowCard>
            <SpecialRateChangeWatcher
              formRenderProps={formRenderProps}
              handleClearSpecialRateDetails={handleClearSpecialRateDetails}
            />
          </FormElement>
        )}
      />
    </>
  );
};

const DeleteHotelSpecialRateDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const location = useLocation();
  const HotelID = location.state?.HotelID;

  const HotelSpecialRateID = useAppSelector(
    (state) => state.hotel.HotelSpecialRateID
  );

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteHotelSpecialRate(ID));
      if (response.meta.requestStatus === "fulfilled") {
        dispatch(getHotelByID(HotelID));
        dispatch(closeDialog());
        dispatch(clearHotelSpecialRateID());
      } else {
        dispatch(getHotelByID(HotelID));
        dispatch(closeDialog());
        dispatch(clearHotelSpecialRateID());
      }
    }
  };
  return (
    <>
      {dialogName === "deleteHotelSpecialRate" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Special Rate?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Special Rate?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(HotelSpecialRateID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default CreateHotelSpecialRate;
